module.exports = __webpack_public_path__ + "img/tekna-logo.593a3ce3.svg";